import { render, staticRenderFns } from "./VerifyScreeningNotices.vue?vue&type=template&id=0fbc3429&scoped=true&"
import script from "./VerifyScreeningNotices.vue?vue&type=script&lang=js&"
export * from "./VerifyScreeningNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc3429",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAlert,VSlideYReverseTransition})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbc3429')) {
      api.createRecord('0fbc3429', component.options)
    } else {
      api.reload('0fbc3429', component.options)
    }
    module.hot.accept("./VerifyScreeningNotices.vue?vue&type=template&id=0fbc3429&scoped=true&", function () {
      api.rerender('0fbc3429', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Application/Setup/VerifyScreeningNotices.vue"
export default component.exports